class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    this.openTimeout = null;
    this.closeTimeout = null;
    
    if (this.isHoverDevice) {
      this.setupHoverBehavior();
    }
  }

  setupHoverBehavior() {
    const summary = this.mainDetailsToggle.querySelector('summary');
    const content = this.mainDetailsToggle.querySelector('.mega-menu__content');
    const url = summary.dataset.url;
    
    // Open on hover with delay
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.closeTimeout);
      this.openTimeout = setTimeout(() => {
        this.open();
      }, 500);
    });
    
    // Close with delay when leaving
    this.addEventListener('mouseleave', () => {
      clearTimeout(this.openTimeout);
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, 300);
    });
    
    // On click, navigate to the menu item's URL
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (url) {
        window.location.href = url;
      }
    });
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
